import { useEffect, useMemo, useRef, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import prepareForOptions from "~services/utils/prepareForOptions";
import { db } from "~/db/db";
import { useLiveQuery } from "dexie-react-hooks";

const useGrupoProduto = ({ formikRef = null, name = 'grupoProdutoId', filial, filiais, filiaisDisponiveis, gruposPorFamilia, camposOpt = ['codigo', 'nome'], gruposDisponiveis, replicacao = false, salvarLocalStorage, chave }) => {

  const grupoProdutoSelect = useSelect("grupoProdutos");
  const [labelGrupoProduto, setLabelGrupoProduto] = useState();
  const [grupoProduto, setGrupoProduto] = useState(0);
  const [onGrupo, setOnGrupo] = useState(false);

  const [gruposProduto, setGruposProduto] = useState([]);

  useEffect(() => {
    const fetchGruposProduto = async (signal) => {
      let query = db.grupoProdutos;
      let wheres = 0;

      if (filial && filiaisDisponiveis && filiaisDisponiveis["key-" + filial] && Object.keys(filiaisDisponiveis["key-" + filial].materiais).length > 0) {
        const materiais = Object.keys(filiaisDisponiveis["key-" + filial].materiais).map((e) => parseInt(e));
        if (materiais.length > 0) {
          query = query.where('id').anyOf(materiais);
          wheres++;
        }
      }

      if (filiais?.length > 0 && filiaisDisponiveis) {
        let materiaisArray = [];
        filiais.forEach((f) => {
          if (filiaisDisponiveis["key-" + f.id] && Object.keys(filiaisDisponiveis["key-" + f.id].materiais).length > 0) {
            const filialMateriais = Object.keys(filiaisDisponiveis["key-" + f.id].materiais).map((e) => parseInt(e));
            if (filialMateriais.length > 0) {
              materiaisArray = materiaisArray.concat(filialMateriais);
            }
          }
        });

        if (materiaisArray.length > 0) {
          if (wheres > 0) query = query.and((a) => materiaisArray.includes(a.id));
          else query = query.where('id').anyOf(materiaisArray);
          wheres++;
        }
      }

      if (gruposDisponiveis) {
        if (wheres > 0) {
          query = query.and((a) => gruposDisponiveis.includes(a.id));
        } else {
          query = query.where('id').anyOf(gruposDisponiveis);
        }
      }

      if (gruposPorFamilia && gruposPorFamilia.length > 0) {
        if (wheres > 0) query = query.and((a) => gruposPorFamilia.includes(a.id));
        else query = query.where('id').anyOf(gruposPorFamilia);
      }

      if (replicacao) {
        query = query.filter((a) => a.replicacaoAtiva !== false);
      }

      const result = [];
      await query.filter((a) => a.ativo).each((item) => result.push(item));

      if (!signal.aborted) {

        setGruposProduto(result);
      }
    };

    const controller = new AbortController();
    const { signal } = controller;

    fetchGruposProduto(signal);

    return () => {
      // Cancela a execução pendente ao desmontar ou ao reexecutar o efeito
      controller.abort();
    };

  }, [filial, filiais, filiaisDisponiveis, gruposPorFamilia, gruposDisponiveis, replicacao]);


  const optionGruposProduto = useMemo(() => prepareForOptions((gruposProduto || []).sort((a, b) => a.nome.localeCompare(b.nome)), camposOpt, 'id'), [gruposProduto])

  function onChangeGrupoProduto(e, setFieldTouched = true) {
    setOnGrupo(e.value > 0)
    setLabelGrupoProduto(e)
    grupoProdutoSelect.upDateValue(e.value);
    grupoProdutoSelect.upDateDefaultValue(e || "");
    if (salvarLocalStorage) {
      localStorage.setItem(chave, JSON.stringify(e));
    }
    if (formikRef?.current) {
      formikRef.current.setFieldValue(name, e.value);

      if (setFieldTouched)
        setTimeout(() => formikRef.current.setFieldTouched(name, true));
    }
    setGrupoProduto(e.value);
  }

  useEffect(() => {
    if(salvarLocalStorage){
      const filialSalva = localStorage.getItem(chave);

      if (filialSalva) {
        const filialObj = JSON.parse(filialSalva);
        setGrupoProduto(filialObj.value);
        onChangeGrupoProduto(filialObj);
        setOnGrupo(filialObj.value);
      }
    }
  }, [])

  function SetSelectGrupoProduto(id) {
    const grupoProduto = optionGruposProduto.find(grupo => grupo.value === id);
    if (grupoProduto)
      onChangeGrupoProduto(grupoProduto)
  }

  function CleanForFilteGrupoProduto(option) {
    onChangeGrupoProduto(option);
    if (!option || !option.value) {
      localStorage.removeItem(chave);
    }
  }

  return {
    gruposProduto,
    optionGruposProduto,
    onChangeGrupoProduto,
    SetSelectGrupoProduto,
    labelGrupoProduto,
    grupoProduto,
    grupoProdutoSelect,
    setGrupoProduto,
    CleanForFilteGrupoProduto,
    onGrupo
  };
}

export default useGrupoProduto;